<template>
  <div>
    <div class="cases-top">
      <div class="cases-top-left">
        <div class="cases-tabs">
          <router-link to="/projects">
            <div
              class="cases-tab cases-tab1"
              :class="isArchived ? '' : 'active'"
            >
              Aktivni projekti
            </div>
          </router-link>
          <router-link to="/finished-projects">
            <div
              class="cases-tab cases-tab2"
              :class="isArchived ? 'active' : ''"
            >
              Završeni
            </div>
          </router-link>
        </div>
        <!-- <div class="period"> -->
        <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateRangeText"
              label="Odaberite period"
              append-icon="mdi-calendar"
              v-bind="attrs"
              @click="menu1 = !menu1"
              v-on="on"
              class="case-date-picker"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="hr"
            v-model="date_range"
            range
            no-title
          ></v-date-picker>
        </v-menu>
      </div>
      <div class="cases-top-right">
        <router-link to="/projects/new/" class="add-case"
          >Unesi novi projekt
          <div class="add-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
            >
              <g>
                <g>
                  <path
                    fill="#fff"
                    d="M10.346 7.733H7.741v2.606a1.737 1.737 0 1 1-3.474 0V7.733H1.662a1.737 1.737 0 0 1 0-3.476h2.605V1.651a1.737 1.737 0 1 1 3.474 0v2.606h2.605a1.737 1.737 0 0 1 0 3.476z"
                  />
                </g>
              </g>
            </svg></div
        ></router-link>
      </div>
    </div>

    <div class="testtable">
      <table class="responstable" v-if="data_loaded" :key="rfrsh_predmet">
        <tr>
          <th>
            BR.
            <div class="downarrow"></div>
          </th>
          <th data-th="Detalji predmeta">
            <span>Datum</span>
            <div class="downarrow"></div>
          </th>
          <th>
            Vezane osobe
            <div class="downarrow"></div>
          </th>
          <th>
            Naziv projekta
            <div class="downarrow"></div>
          </th>
          <th>
            Članovi tima
            <div class="downarrow"></div>
          </th>
        </tr>
        <tr v-for="(single_case, key) in all_projects_data" :key="key">
          <td>
            <router-link :to="base_url + single_case.group_url + '/'">
              <b>{{ single_case.broj_projekta }}</b></router-link
            >
          </td>
          <td>{{ switchDate(!single_case.is_archived ?  single_case.datum_pocetka : single_case.datum_arhiviranja) }}</td>
          <td>
            <a
              href="#"
              v-if="
                single_case.connect_project_legal.length == 0 &&
                single_case.connect_project_private.length == 0
              "
              >N/A</a
            >
            <router-link
              :to="
                '/osobe/prav/' +
                single_case.connect_project_legal[0].pravna_osoba.uid
              "
              v-if="single_case.connect_project_legal.length > 0"
              >{{ single_case.connect_project_legal[0].pravna_osoba.ime }}
            </router-link>
            <router-link
              :to="
                '/osobe/fiz/' +
                single_case.connect_project_private[0].fizicka_osoba.uid
              "
              v-if="
                single_case.connect_project_private.length > 0 &&
                single_case.connect_project_legal.length == 0
              "
            >
              {{ single_case.connect_project_private[0].fizicka_osoba.ime }}
              {{
                single_case.connect_project_private[0].fizicka_osoba.prezime
              }}</router-link
            >

            <v-tooltip
              right
              v-if="
                single_case.connect_project_private.length +
                  single_case.connect_project_legal.length >
                1
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <!-- <v-btn color="primary" dark v-bind="attrs" v-on="on">
                    Right
                  </v-btn> -->
                <img
                  v-bind="attrs"
                  v-on="on"
                  class="more-dots"
                  src="@/assets/img/more.svg"
                />
              </template>
              <p
                v-for="(stranka, key) in single_case.connect_project_private"
                :key="'1' + key"
              >
                {{ stranka.fizicka_osoba.ime }}
                {{ stranka.fizicka_osoba.prezime }}
              </p>
              <p
                v-for="(stranka, key) in single_case.connect_project_legal"
                :key="'2' + key"
              >
                {{ stranka.pravna_osoba.ime }}
              </p>
            </v-tooltip>
          </td>

          <td>
            <router-link :to="base_url + single_case.group_url + '/'">{{
              single_case.name
            }}</router-link>
          </td>
          <td>
            <a href="#" v-if="single_case.connect_project_odvjetnik.length == 0"
              >N/A</a
            >
            <router-link
              :to="
                '/osobe/law/' +
                single_case.connect_project_odvjetnik[0].odvjetnik.uid
              "
              v-else
              >{{ single_case.connect_project_odvjetnik[0].odvjetnik.ime }}
              {{
                single_case.connect_project_odvjetnik[0].odvjetnik.prezime
              }}</router-link
            >
            <v-tooltip
              right
              v-if="single_case.connect_project_odvjetnik.length > 1"
            >
              <template v-slot:activator="{ on, attrs }">
                <!-- <v-btn color="primary" dark v-bind="attrs" v-on="on">
                    Right
                  </v-btn> -->
                <img
                  v-bind="attrs"
                  v-on="on"
                  class="more-dots"
                  src="@/assets/img/more.svg"
                />
              </template>
              <p
                v-for="(stranka, key) in single_case.connect_project_odvjetnik"
                :key="key"
              >
                {{ stranka.odvjetnik.ime }} {{ stranka.odvjetnik.prezime }}
              </p>
            </v-tooltip>
          </td>
        </tr>
      </table>
    </div>

    <div class="cases-pagination">
      <div class="cases-pagination-left">
        <div class="pagin-wrapp page-nav" v-if="popis_brojeva_stranica.length>1">
          <div class="page-nav-prev" v-if="!isFirstPage" @click="setPage(curr_page - 1)">
            <svg id="SVGDoc" width="71" height="72" xmlns="http://www.w3.org/2000/svg" version="1.1"
              xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 71 72">
              <defs>
                <clipPath id="ClipPath1018">
                  <path
                    d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                    fill="#ffffff"></path>
                </clipPath>
              </defs>
              <g>
                <g>
                  <g>
                    <path class="sssdf"
                      d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                      fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                      stroke-linecap="butt" stroke-opacity="1" stroke="#c2c2c2" stroke-miterlimit="20" stroke-width="2"
                      clip-path='url("#ClipPath1018")'></path>
                  </g>
                  <g>
                    <g>
                      <path class="sssdr" d="M37.11694,40.02775v0l-4.09639,-4.09664v0l4.09639,-4.09638v0"
                        fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray=""
                        stroke-linejoin="miter" stroke-linecap="butt" stroke-opacity="1" stroke="#2b2b41"
                        stroke-miterlimit="20" stroke-width="2"></path>
                    </g>
                    <g>
                      <path d="M40.30245,40.02775v0l-4.09651,-4.09664v0l4.09651,-4.09638v0" fill-opacity="0"
                        fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                        stroke-linecap="butt" stroke-opacity="1" stroke="#f6eeff" stroke-miterlimit="20"
                        stroke-width="2"></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <div class="page-nav-no">
            <div :class="{ 'curr-page': curr_page == 1 }" @click="setPage(1)">
              1
            </div>
          </div>
          <div class="page-nav-no" v-if="left_dots_visible">
            <div>
              ...
            </div>
          </div>
          <div class="page-nav-no" v-for="(str, key) in getLeftRightPages" :key="key" @click="setPage(str)">
            <div :class="{ 'curr-page': curr_page == str }">
              {{ str }}
            </div>
          </div>
          <div class="page-nav-no" v-if="right_dots_visible">
            <div>
              ...
            </div>
          </div>
          <div class="page-nav-no" v-if="popis_brojeva_stranica.length>1">
          <div :class="{ 'curr-page': curr_page == popis_brojeva_stranica.length }"
            @click="setPage(popis_brojeva_stranica.length)">
            {{ popis_brojeva_stranica.length }}
          </div>
          </div>
          <div class="page-nav-next" v-if="!isLastPage" @click="setPage(curr_page + 1)">
            <svg id="SVGDoc" width="71" height="72" xmlns="http://www.w3.org/2000/svg" version="1.1"
              xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 71 72">
              <defs>
                <clipPath id="ClipPath1043">
                  <path
                    d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                    fill="#ffffff"></path>
                </clipPath>
              </defs>
              <g>
                <g>
                  <g>
                    <path class="sssdf"
                      d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                      fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                      stroke-linecap="butt" stroke-opacity="1" stroke="#c2c2c2" stroke-miterlimit="20" stroke-width="2"
                      clip-path='url("#ClipPath1043")'></path>
                  </g>
                  <g>
                    <g>
                      >
                      <path class="sssdr" d="M33.88303,40.02775v0l4.09651,-4.09664v0l-4.09651,-4.09638v0"
                        fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray=""
                        stroke-linejoin="miter" stroke-linecap="butt" stroke-opacity="1" stroke="#2b2b41"
                        stroke-miterlimit="20" stroke-width="2"></path>
                    </g>
                    <g>
                      <path d="M30.69751,40.02775v0l4.09663,-4.09664v0l-4.09663,-4.09638v0" fill-opacity="0"
                        fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                        stroke-linecap="butt" stroke-opacity="1" stroke="#f6eeff" stroke-miterlimit="20"
                        stroke-width="2"></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
        </div>
        <!-- <img style="width:16rem;" src="@/assets/img/paginacija2.svg"> -->
      </div>
      <div class="cases-pagination-right">
        Broj redova po stranici
        <div class="broj-redova">
          <select id="search-group" v-model="broj_projekta">
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
          </select>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="7"
            height="11"
            viewBox="0 0 7 11"
          >
            <g>
              <g>
                <path
                  fill="#3326ae"
                  d="M.204 3.503a.754.754 0 0 0 .572.264c.18 0 .354-.065.506-.196l1.816-1.828L4.92 3.571c.142.142.33.22.53.22.202 0 .39-.078.533-.22a.76.76 0 0 0 0-1.065L3.632.14A.748.748 0 0 0 3.1-.077c-.2 0-.388.077-.53.22L.203 2.522a.754.754 0 0 0 0 .98z"
                />
              </g>
              <g>
                <path
                  fill="#3326ae"
                  d="M6.026 7.411a.758.758 0 0 0-1.083-.067L3.12 9.17 1.291 7.343a.75.75 0 0 0-.532-.22.75.75 0 0 0-.534.221.757.757 0 0 0 0 1.065l2.36 2.364a.752.752 0 0 0 .533.219c.201 0 .39-.078.534-.22l2.374-2.38a.752.752 0 0 0 0-.98z"
                />
              </g>
            </g>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import auth from "@/services/auth";
import GroupList from "@/components/generalComponents/GroupList";
import proj_hand from "@/apiCallers/promise_handler_db/projects";
import share from "@/apiCallers/sharepoint";
import moment from "moment";
import gsap from "gsap";

export default {
  components: { GroupList },
  data() {
    return {
      date_range: [],
      accessToken: "",
      dohvaceni_predmeti: [],
      prav_protustranke: [],
      prav_stranke: [],
      fiz_stranke: [],
      fiz_protustranke: [],
      all_projects_data: [],
      base_url: "/projects/",

      rfrsh_predmet: 1,

      // Paginacija start
      popis_brojeva_stranica: [],
      curr_page: 1,
      broj_projekta: 5,
      //Paginacija end

      //filteri START
      vrste_postupka: [],
      selektirani_postupak: 0,
      faze_postupka: [],
      selektirana_faza: 0,
      isArchived: false,
      //filteri END

      odvjetnici: [],
      data_loaded: false,
      menu1:false,
      left_dots_visible: false,
      right_dots_visible: false,
    };
  },
  async created() {
    if (this.$route.name === "FinishedProjects") {
      this.isArchived = true;
      this.base_url = "/finished-projects/";
    }

    console.log(this.isArchived, " Arhiviran?");
    this.accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
    proj_hand
      .getAll(
        this.accessToken,
        this.curr_page,
        this.broj_projekta,
        null,
        null,
        this.isArchived
      )
      .then((response) => {
        console.log(response.data);
        this.all_projects_data = response.data.project_list;
        this.data_loaded = true;
        this.popis_brojeva_stranica = response.data.popis_brojeva_stranica;
      });
    //  this.addNewGroup();
    // console.log(this.accessToken)
  },
  computed: {
    isFirstPage() {
      return this.curr_page == 1;
    },
    isLastPage() {
      return (
        this.curr_page ==
        this.popis_brojeva_stranica[this.popis_brojeva_stranica.length - 1]
      );
    },
    dateRangeText() {
      var ret_date_string = [];
      this.date_range.forEach((p) => {
        ret_date_string.push(moment(p).format("l"));
      });
      return ret_date_string.join(" ~ ");
    },
    getLeftRightPages() {
      // Init values
      let return_pages = []
      this.right_dots_visible = false;
      this.left_dots_visible = false;
      // Left of current page
      // 3 is the bottom value to make ... sense
      // LEFT LOOP
      let left_start = 2;
      let left_end = this.curr_page;
      if(this.curr_page == this.popis_brojeva_stranica.length)
        left_end = this.curr_page-1;
      if (this.curr_page > 3) {
        left_start = this.curr_page - 1;
        this.left_dots_visible = true;
      }
      for (let j = left_start; j <= left_end; j++) {
        return_pages.push(j);
      }
      // RIGHT LOOP
      let right_start = this.curr_page + 1;
      if (right_start < this.popis_brojeva_stranica.length)
        return_pages.push(right_start);
      if(right_start < this.popis_brojeva_stranica.length-1)
      this.right_dots_visible = true;
      return return_pages
    },
  },
  watch: {
    curr_page: function () {
      this.getNewData();
    },

    broj_projekta: function () {
      this.getNewData();
    },
    date_range: function () {
      this.getNewData();
    },

    selektirana_faza: function () {
      this.curr_page = 1;
      this.getNewData();
    },
    selektirani_postupak: function () {
      this.curr_page = 1;
      this.getNewData();
    },
  },
  methods: {
    async getNewData() {
      this.accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
      var start_date = null;
      var end_date = null;

      if (this.date_range.length > 0) {
        start_date = this.date_range[0];
        if (this.date_range.length > 1) {
          end_date = this.date_range[1];
        }
      }
      proj_hand
        .getAll(
          this.accessToken,
          this.curr_page,
          this.broj_projekta,
          start_date,
          end_date,
          this.isArchived
        )
        .then((response) => {
          this.all_projects_data = response.data.project_list;
          this.data_loaded = true;
          this.popis_brojeva_stranica = response.data.popis_brojeva_stranica;
          //table return animation
          gsap.to(".responstable", 0.5, { opacity: 1, x: 0 });
        });
    },
    setPage(str) {
      console.log("Odabrana je stranica " + str);
      this.curr_page = parseInt(str);
      console.log(this.curr_page);

      //table initial animation
      gsap.to(".responstable", 0.5, { opacity: 0, x: -10 });
    },
    switchDate(inData) {
      return moment(inData.toString()).format("l");
    },
    getYear(inData) {
      return moment(inData.toString()).format("YYYY");
    },
    fullLogout() {
      auth.clearLocal();
      auth.logout();
      this.$router.push({ path: "/login" });
    },

    addNewGroup() {
      var tempGroup = {
        description: "2021-213",
        displayName:
          "2021-213 GOLUBOVECKI KAMENOLOMI D.O.O. - CT CONSTRUCTION MANAGEMENT D.O.O",
        groupTypes: ["Unified"],
        mailEnabled: true,
        visibility: "Hiddenmembership",
        mailNickname: "2021-213",
        securityEnabled: false,
      };
      var resp = null;
      share.addNewGroup(this.accessToken, tempGroup).then((response) => {
        console.log(response);
        resp = response;
      });
    },
  },
  mounted() {
    // this.addNewGroup();

    //paginacija
    this.$store.state.paginacija.title = "Upravljanje projektima";
  },
};
</script>

<style>
</style>